import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { mfaGuard } from './core/guards/mfa.guard';
import { AuthService } from './core/services/auth.service';

/** Lazy children shared by web and mobile under `/:tenantId/app`. */
export const crewAppChildRoutes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'tasks',
    loadComponent: () => import('./features/tasks/task-list/task-list.component').then(m => m.TaskListComponent)
  },
  {
    path: 'schedule',
    loadComponent: () => import('./features/schedule/schedule.component').then(m => m.ScheduleComponent)
  },
  {
    path: 'time',
    loadComponent: () => import('./features/time/time.component').then(m => m.TimeComponent)
  },
  {
    path: 'worklogs',
    loadComponent: () => import('./features/worklogs/worklogs.component').then(m => m.WorklogsComponent)
  },
  {
    path: 'receipts',
    loadComponent: () => import('./features/receipts/receipts.component').then(m => m.ReceiptsComponent)
  },
  {
    path: 'punch-list',
    loadComponent: () => import('./features/punch-list/punch-list.component').then(m => m.PunchListComponent)
  },
  {
    path: 'selections',
    loadComponent: () => import('./features/selections/selections.component').then(m => m.SelectionsComponent)
  },
  {
    path: 'files',
    loadComponent: () => import('./features/files/files.component').then(m => m.FilesComponent)
  },
  {
    path: 'messages',
    loadComponent: () => import('./features/messages/thread-list/thread-list.component').then(m => m.ThreadListComponent)
  },
  {
    path: 'messages/:threadId',
    loadComponent: () => import('./features/messages/thread-list/thread-list.component').then(m => m.ThreadListComponent)
  },
  {
    path: 'profile',
    loadComponent: () => import('./features/profile/profile.component').then(m => m.ProfileComponent)
  }
];

export const authRoutes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./features/auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
  },
  {
    path: 'create-password',
    loadComponent: () => import('./features/auth/create-password/create-password.component').then(m => m.CreatePasswordComponent)
  },
  {
    path: 'set-new-password',
    loadComponent: () => import('./features/auth/set-new-password/set-new-password.component').then(m => m.SetNewPasswordComponent)
  },
  {
    path: 'mfa',
    loadComponent: () => import('./features/auth/mfa/mfa.component').then(m => m.MfaComponent),
    canActivate: [mfaGuard]
  }
];

export const catchAllRoute: Routes = [
  {
    path: '**',
    redirectTo: () => {
      const auth = inject(AuthService);
      const tenantId = auth.tenantId;
      return auth.isAuthenticated() && tenantId ? `/${tenantId}/app/dashboard` : '/login';
    }
  }
];
